<template>
  <div>
    <TheAthletesPerformanceOverview
      :class="$style.performanceWrapper"
      class="px-2 py-3"
      :athletes="athletes"
    />

    <div
      class="d-flex justify-content-center py-4"
      :class="$style.navigationWrapper"
    >
      <router-link
        :to="{ name: 'match' }"
        class="mr-1"
      >
        <BaseButton
          :variant="$router.currentRoute.name === 'match' ? 'orange' : 'outline-orange'"
          font-size="small"
          left-rounded
        >
          {{ $t('match-performance') }}
        </BaseButton>
      </router-link>

      <router-link :to="{ name: 'match-current-standings' }">
        <BaseButton
          :variant="$router.currentRoute.name === 'match-current-standings' ? 'orange' : 'outline-orange'"
          font-size="small"
          right-rounded
        >
          {{ $t('current-round-standings') }}
        </BaseButton>
      </router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
import TheAthletesPerformanceOverview from '@/components/Molecules/TheAthletesPerformanceOverview'
import BaseButton from '@/components/Atoms/BaseButton'
export default {
  name: 'MatchLiveAndFinished',
  components: {
    BaseButton,
    TheAthletesPerformanceOverview,
  },
  props: {
    athletes: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../assets/scss/variables";
  .performanceWrapper {
    border-top: 1px solid $color-windswept-beach;
  }
  .navigationWrapper {
    background-color: $color-white;
    border-top: 1px solid $color-windswept-beach;
    border-bottom: 1px solid $color-windswept-beach;
  }
</style>
